export default "__VITE_ASSET__135c7e89__$_?react__"